import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { cn } from '@/lib/utils';
    import { AvatarFallback, type AvatarFallbackProps } from 'reka-ui';
    import { computed, type HTMLAttributes } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AvatarFallback',
  props: {
    delayMs: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  setup(__props: any) {

    const props = __props;

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;

        return delegated;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AvatarFallback), _mergeProps({ "data-slot": "avatar-fallback" }, delegatedProps.value, {
    class: 
            _unref(cn)(
                'text-foreground bg-background flex h-full w-full items-center justify-center text-xs leading-1 font-bold',
                props.class,
            )
        
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})